import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material';
import { MatProgressSpinnerModule } from '@angular/material';
import { MatPaginatorIntl, MatPaginatorModule, MatSortModule, MatTableModule } from '@angular/material';

import { MatButtonModule, MatButtonToggleModule, MatInputModule } from '@angular/material';
import { MatFormFieldModule, MatNativeDateModule, MatDatepickerModule } from '@angular/material';
import { MatMenuModule } from '@angular/material';
import { MatGridListModule } from '@angular/material';
import { MatCheckboxModule } from '@angular/material';
import { MatRadioModule } from '@angular/material';
import { MatTooltipModule } from '@angular/material';
import { MatExpansionModule } from '@angular/material';
import { MatSlideToggleModule } from '@angular/material';
import { MatProgressBarModule } from '@angular/material';

import { MatTabsModule } from '@angular/material';
import { MatToolbarModule, MatSelectModule, MatOptionModule } from '@angular/material';
import { MatCardModule } from '@angular/material';
import { MatSidenavModule } from '@angular/material';

export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  itemsPerPageLabel = 'Elementi per pagina:';
  nextPageLabel     = 'Prossima pagina';
  previousPageLabel = 'Precedente pagina';
}

@NgModule({
  imports: [
	MatIconModule,
	MatProgressSpinnerModule,
	MatPaginatorModule,
	MatSortModule,
	MatTableModule,
	MatButtonModule,
	MatButtonToggleModule,
	MatInputModule,
	MatFormFieldModule,
	MatNativeDateModule,
	MatDatepickerModule,
	MatMenuModule,
	MatGridListModule,
	MatCheckboxModule,
	MatRadioModule,
	MatTooltipModule,
	MatExpansionModule,
	MatSlideToggleModule,
	MatProgressBarModule,
	MatTabsModule,
	MatToolbarModule,
	MatSelectModule,
	MatOptionModule,
	MatCardModule,
	MatSidenavModule,
	],
	providers: [
		{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }
	],
  exports: [
	MatIconModule,
	MatProgressSpinnerModule,
	MatPaginatorModule,
	MatSortModule,
	MatTableModule,
	MatButtonModule,
	MatButtonToggleModule,
	MatInputModule,
	MatFormFieldModule,
	MatNativeDateModule,
	MatDatepickerModule,
	MatMenuModule,
	MatGridListModule,
	MatCheckboxModule,
	MatRadioModule,
	MatTabsModule,
	MatTooltipModule,
	MatExpansionModule,
	MatSlideToggleModule,
	MatProgressBarModule,
	MatToolbarModule,
	MatSelectModule,
	MatOptionModule,
	MatCardModule,
	MatSidenavModule,
	],
})
export class MaterialModule { }
